import { FaCalendar, FaClock } from "react-icons/fa"

import img from '../assets/children-up (1).jpeg'

const UpcomingEvent = () => {

    return (
        <section className="bg-[#f9fafb] w-full py-6">
            <div className="lg:w-[80%] md:w-[100%] sm:w-[100%] lg:m-auto md:m-auto sm:m-0  px-4 py-8 my-8 mx-0">
                <div className="text-center">
                    <h1 className=" font-bold text-3xl">Événement à venir</h1>
                    <p className="text-[20px] py-2">Découvrez  tous les  détails de nos evenements à venir</p>
                </div>
                <div className="flex flex-col md:flex-row justify-around gap-4 m-auto items-center bg-white shadow-lg p-10  my-16 border">
                    <div className="text-center bg-orange-400 py-16 px-10 text-white md:w-1/4 xm:w-[100%]">
                        <p>Jul</p>
                        <h1 className="font-bold text-6xl">12</h1>
                    </div>
                    <div className="md:w-[400px] md:mx-2 mt-6 md:mt-0 px-2 py-2">
                        <div className="flex flex-col md:flex-row gap-12">
                            <div className="flex items-center py-2">
                                <FaCalendar />
                                <p>12 Nov 2023</p>
                            </div>
                            <div className="flex items-center  py-2">
                                <FaClock />
                                <p>8h AM, 12PM</p>
                            </div>
                        </div>
                        <h1 className="font-bold">Theme</h1>
                        <p>Explication de l'evenement sur l'evenement en question</p>
                    </div>
                    <div className="text-center md:w-1/4 mt-6 md:mt-0">
                        <img src={img} width={250} height={250} alt="img" />
                    </div>
                </div>
            </div>

        </section>
    )
}

export default UpcomingEvent